import React from "react";
import GenericAdminCRUD from "../components/GenericAdminCRUD";

export default function ClientTalkieEditor() {
  return (
    <GenericAdminCRUD
      title="Pesquisas Talkie"
      subtitle="Cadastre relatórios de pesquisas Talkie do cliente. Aparecem em /cliente/talkie."
      path="client-talkie"
      fields={[
        { key: "client_id", label: "Cliente *", type: "clientSelect" },
        { key: "title", label: "Título da pesquisa *", type: "text" },
        { key: "date", label: "Data", type: "date" },
        { key: "respondents", label: "Nº de respondentes", type: "number" },
        { key: "url", label: "URL do relatório", type: "text" },
        { key: "summary", label: "Resumo", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "title", label: "Pesquisa" },
        { key: "date", label: "Data" },
        { key: "respondents", label: "Respondentes" },
        { key: "client_id", label: "Cliente", render: (it, { clients }) => clients.find((c) => c.id === it.client_id)?.company || "—" },
      ]}
    />
  );
}
